interface StatusBadgeProps {
  status: string;
}

const imgStyle = { height: 108, width: "auto" };

export default function StatusBadge({ status }: StatusBadgeProps) {
  switch (status) {
    case "SYSTEM_VERIFIED":
      return <img src="/SystemVerifiedStamp.svg" alt="System Verified" style={imgStyle} />;
    case "VERIFIED":
      return <img src="/VerifiedStamp.svg" alt="Verified" style={imgStyle} />;
    case "UNDER_REVIEW":
      return <img src="/UnderReviewStamp.svg" alt="Under Review" style={imgStyle} />;
    case "ACTION_REQUIRED":
      return <img src="/ActionRequiredStamp.svg" alt="Action Required" style={imgStyle} />;
    case "DRAFT":
    default:
      return <img src="/DraftStamp.svg" alt="Draft" style={imgStyle} />;
  }
}
